export default __webpack_public_path__ + "images/3d0375c28ecfcd909f5c1e7a9877ff38-track_and_field.webp";